export const notificationGroups = (state) => state.notifications?.groups;
export const getGroupById = (id) => (state) => notificationGroups(state).find((group) => group.id === id);
export const notification = (id) => (state) => state.notification;
